import axios from 'axios';

const api = axios.create({
    baseURL: 'https://cornflowerblue-crow-411585.hostingersite.com/api',
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default api;